export const loginFailureResponse = {
  code: 401,
  reason: 'Unauthorized',
  message: 'Login failure',
};
